module.exports = __webpack_public_path__ + "static/Azhar-Chaudhry-7b45f571281ffbb74f8fb588636fe034.jpg";